import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';


function TenantForm() {
    const [formData, setFormData] = useState({
        login: '',
        title: '',
        password: '',
        repeatPassword: '',
    });
    const [error, setError] = useState('');
    const navigate = useNavigate(); 

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });

        // Clear the error when user starts typing
        if (name === 'password' || name === 'repeatPassword') {
            setError('');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Passwords match validation
        if (formData.password !== formData.repeatPassword) {
            setError('Passwords do not match.');
            return;
        }

        console.log('Form submitted:', formData);
        // Make API request here

        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/tenant`, {
            method: 'POST',
            credentials: "include",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                login: formData.login,
                title: formData.title,
                passwd: formData.password
            })
        });
        if (response.ok) {
            navigate('/');
        } else if (response.status === 401) {
            Cookies.remove('session-id');
            navigate('/login');
        } else {
            setError('Internal server error, tenant not created.');
            return;
        }
    };

    return (
        <div className='flex items-center justify-center mt-20'>
            <div className="w-1/3 p-6 bg-white shadow-md rounded-lg mx-auto"> 
                <h2 className="text-2xl font-bold mb-4 text-center">Add New Tenant</h2>
                <form onSubmit={handleSubmit} className="space-y-4">
                    {/* Login Field */}
                    <div>
                        <label htmlFor="login" className="block text-sm font-medium text-gray-700 mb-1">
                            Login
                        </label>
                        <input
                            type="text"
                            id="login"
                            name="login"
                            value={formData.login}
                            onChange={handleChange}
                            placeholder="Enter login"
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500"
                            required
                        />
                    </div>

                    {/* Title Field */}
                    <div>
                        <label htmlFor="title" className="block text-sm font-medium text-gray-700 mb-1">
                            Title
                        </label>
                        <input
                            type="text"
                            id="title"
                            name="title"
                            value={formData.title}
                            onChange={handleChange}
                            placeholder="Enter title"
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500"
                            required
                        />
                    </div>

                    {/* Password Field */}
                    <div>
                        <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
                            Password
                        </label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            placeholder="Enter password"
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500"
                            required
                        />
                    </div>

                    {/* Repeat Password Field */}
                    <div>
                        <label htmlFor="repeatPassword" className="block text-sm font-medium text-gray-700 mb-1">
                            Repeat Password
                        </label>
                        <input
                            type="password"
                            id="repeatPassword"
                            name="repeatPassword"
                            value={formData.repeatPassword}
                            onChange={handleChange}
                            placeholder="Repeat password"
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500"
                            required
                        />
                    </div>

                    {/* Error Message */}
                    {error && (
                        <p className="text-red-500 text-sm mt-1">{error}</p>
                    )}

                    {/* Submit Button */}
                    <button
                        type="submit"
                        className="w-full bg-blue-500 text-white py-2 px-4 rounded-lg hover:bg-blue-600 transition duration-200"
                    >
                        Submit
                    </button>
                </form>
            </div>
        </div>
    );
}

export default TenantForm;
